<template>
  <v-layout>
    <div class="columns small-6 small-push-3">
      <h1>{{ $t('storeUserLogin.changePassword.title') }}</h1>

      <form id="setpassword" method="post">
        <fieldset class="warning">
          <div class="form-row inline-label">
            <div class="form-column">
              <label :title="$t('storeUserLogin.changePassword.form.passwordTitle')" for="new_password" class="password required">{{ $t('storeUserLogin.changePassword.form.passwordLabel') }}</label>
              <input id="new_password" v-model="password" type="password" name="new_password">
            </div>
          </div>
          <ul v-if="passwordErrorCode || (passwordError && $v.password.$dirty)" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
            <li v-if="passwordErrorCode">{{ $t('storeUserLogin.changePassword.error.' + passwordErrorCode) }}</li>
            <li v-if="passwordError">{{ $t('storeUserLogin.changePassword.error.' + passwordError) }}</li>
          </ul>
          <div class="form-row inline-label">
            <div class="form-column">
              <label for="new_password_repeat" class="required">{{ $t('storeUserLogin.changePassword.form.repeatPasswordLabel') }}</label>
              <input id="new_password_repeat" v-model="repeatPassword" type="password" name="new_password_repeat">
            </div>
          </div>
          <ul v-if="repeatPasswordError && $v.repeatPassword.$dirty" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
            <li v-if="repeatPasswordError">{{ $t('storeUserLogin.changePassword.error.' + repeatPasswordError) }}</li>
          </ul>
        </fieldset>
        <fieldset class="submit">
          <div class="form-row">
            <div class="form-column">
              <button id="submit-login" type="button" name="submit-login" @click.prevent="submitForm()">{{ $t('storeUserLogin.changePassword.form.submit') }}</button>
            </div>
            <div class="form-column">
              <router-link :to="{ name: 'StoreUserLogin' }">{{ $t('storeUserLogin.changePassword.form.cancel') }}</router-link>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import VModal from '../components/modals/Modal'
import authenticationMixin from '../mixins/authentication'
import bodyClassMixin from '../mixins/body-class'
import { validationMixin } from 'vuelidate'
import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'StoreUserChangePassword',
  components: {
    VLayout,
    VModal
  },
  mixins: [
    authenticationMixin,
    bodyClassMixin,
    validationMixin
  ],
  data () {
    return {
      password: null,
      repeatPassword: null,
      passwordErrorCode: null
    }
  },
  computed: {
    passwordError: function () {
      for (let validatorName of Object.keys(this.$v.password.$params)) {
        if (!this.$v.password[validatorName]) {
          return validatorName
        }
      }
    },
    repeatPasswordError: function () {
      for (let validatorName of Object.keys(this.$v.repeatPassword.$params)) {
        if (!this.$v.repeatPassword[validatorName]) {
          return validatorName
        }
      }
    }
  },
  validations () {
    return {
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(32)
      },
      repeatPassword: {
        required,
        sameAs: sameAs('password')
      }
    }
  },
  async mounted () {
    try {
      await this.$container.userApiClient.validateChangePasswordToken(this.$route.params.token)
    } catch (error) {
      this.$router.push({ name: 'StoreUserLogin', params: { error: error.errors[0].code } }).catch(() => {})
    }
  },
  methods: {
    submitForm: async function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        try {
          await this.$container.userApiClient.changePassword(this.$route.params.token, this.password)
          this.$router.push({ name: 'StoreUserLogin', params: { flash: 'storeUserLogin.changePassword.passwordChanged' } }).catch(() => {})
        } catch (error) {
          if (error.errors.length > 0 && error.errors[0].code) {
            this.passwordErrorCode = error.errors[0].code
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  form {
    width: 100%;
  }
  fieldset.submit {
    width: 100%;
  }
  fieldset.submit .form-column {
    width: 50%;
    float: left;
  }
  fieldset.submit .form-column:last-child {
    padding-top: 12px;
    text-align: right;
  }
</style>

<style>
  #forgot-password-dialog {
    max-width: 40rem;
  }
  #forgot-password-dialog form {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/StoreUserChangePassword.vue